/* eslint-disable no-unused-vars */
import React, { useState, useEffect, useRef } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import axios from 'axios';
import NumberFormat from 'react-number-format';
import Modal from '@bitcoin-portal/bitcoincom-pkg-components/dist/Modal';
import QRCode from '@bitcoin-portal/bitcoincom-pkg-components/dist/QRCode';
import PropTypes from 'prop-types';
import { handleRipple } from '../../../helpers/ripple';
import {
  Wrapper,
  Itemswrapper,
  IconImage,
  Number,
  Text,
  StyledButton,
  NumberTextWrapper,
  Mobilewrapper,
  NumberTextWrappermobile,
} from './styled';
import {
  QrCodeWrapper,
  StyledTitle,
  StyledSubtitle,
  ModalWrapper,
} from '../../../components/QrCodeModal/styled';

import StoreToggle from '../../../components/QrCodeModal/StoreToggle';

const WalletsCreated = ({ template }) => {
  const modalRef = useRef();
  const { messages } = useIntl();
  const [selectedStore, setSelectedStore] = useState('GOOGLE_PLAY');

  const qrValue =
    selectedStore === 'GOOGLE_PLAY'
      ? messages['global.qrcodeModal.google-play.link']
      : messages['global.qrcodeModal.app-store.link'];

  const errvalue = messages['global.counter.value'];
  const [value, setValue] = useState(<span>{errvalue}</span>);

  useEffect(() => {
    const getWalletCount = async () => {
      try {
        const result = await axios.get(
          messages['global.counter.api.walletCount'],
        );
        const numWallets = result.data.totalWalletsCreated;
        const roundedNum = Math.floor(numWallets / 1000) * 1000;
        const val =
          roundedNum && typeof roundedNum === 'number' ? (
            <NumberFormat
              value={roundedNum}
              displayType="text"
              thousandSeparator
            />
          ) : (
            <span>{errvalue}</span>
          );

        setValue(val);
      } catch (error) {
        setValue(<span>{errvalue}</span>);
      }
    };

    getWalletCount();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <Wrapper>
        <Itemswrapper>
          <IconImage
            src={messages['global.counter.icon.src']}
            alt={messages['global.counter.icon.alt']}
          />
          <NumberTextWrapper>
            <Number>{value}&nbsp;</Number>
            <Text>
              <FormattedMessage
                tagName="span"
                id="global.counter.wallets"
                values={{ value: '' }}
              />
            </Text>
          </NumberTextWrapper>
        </Itemswrapper>
        <StyledButton
          onMouseEnter={handleRipple}
          design="primary"
          className="ga-wallet-cta get-app-cta-button"
          onClick={() => modalRef.current.open()}
        >
          {messages['global.counter.button']}
        </StyledButton>
      </Wrapper>
      <Mobilewrapper>
        <Itemswrapper>
          <IconImage
            src={messages['global.counter.icon.src']}
            alt={messages['global.counter.icon.alt']}
          />
          <NumberTextWrappermobile>
            <Number>{value}&nbsp;</Number>
            <Text>
              <FormattedMessage
                tagName="span"
                id="global.counter.wallets"
                values={{ value: '' }}
              />
            </Text>
          </NumberTextWrappermobile>
        </Itemswrapper>
        <StyledButton
          design="secondary"
          onClick={() => {
            document.querySelector('.get-app-cta-button').click();
          }}
        >
          {messages['global.counter.button']}
        </StyledButton>
      </Mobilewrapper>
      <ModalWrapper>
        <Modal ref={modalRef}>
          <StyledTitle>{messages['global.qrcodeModal.title']}</StyledTitle>
          <StyledSubtitle>
            {messages['global.qrcodeModal.description']}
          </StyledSubtitle>
          <StoreToggle
            selectedStore={selectedStore}
            setSelectedStore={setSelectedStore}
          />
          <QrCodeWrapper>
            <QRCode value={qrValue} />
          </QrCodeWrapper>
        </Modal>
      </ModalWrapper>
    </>
  );
};

WalletsCreated.propTypes = {
  template: PropTypes.string.isRequired,
};

export default WalletsCreated;
